import React from "react";
import { Button, Flex } from "@ipc/ipc-components";
import { httpOnlySecurityService } from "../../externals/iam";
import { getProperty } from "../../externals/PropertiesService";

const LoginFailPage = () => {
  function goLoginPage() {
    const loginUrl = `${getProperty("FRONT_END_URL")}/#/en/login`;
    window.location.href = loginUrl;
  }

  const handleLogout = () => {
    if (httpOnlySecurityService?.isUserAuthenticated()) {
      httpOnlySecurityService.logout();
    } else {
      window.location.href = "https://sts.corp.ipc.be/adfs/oauth2/logout";
    }
  };

  return (
    <div>
      <Flex
        flexDirection="row"
        align="center"
        justifyContent="space-between"
        mt="30px"
      >
        <Button variant="default" onClick={goLoginPage}>
          Login Page
        </Button>
        <Button marginLeft="15px" variant="default" onClick={handleLogout}>
          Logout
        </Button>
      </Flex>
    </div>
  );
};

export default LoginFailPage;
